import { Reducer } from "redux";

import { CreatePatientResponse } from "../models/api/Master";
import { CreatePatientDispatchTypes } from "../models/dispatchTypes/Patient";
import { CreatePatientActionDispatchTypes, InformationResponseDefaultValues } from "../constants/Patient";

const initialState: CreatePatientResponse = {
  loading: false,
  response: InformationResponseDefaultValues,
  error: null,
};

const PostCreatePatientReducer: Reducer<
CreatePatientResponse,
CreatePatientDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case CreatePatientActionDispatchTypes.CREATE_PATIENT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case CreatePatientActionDispatchTypes.CREATE_PATIENT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case CreatePatientActionDispatchTypes.CREATE_PATIENT_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case CreatePatientActionDispatchTypes.CREATE_PATIENT_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostCreatePatientReducer;
